<template>
  <div>
    <b-modal id="modal-delivery-select"
             :title="'送貨狀態'"
             centered
             hide-footer
             no-stacking
             no-enforce-focus>
        <div class="status-card">
            <span v-if="!redemptionItem.deliveryStatus">
              待發貨
            </span>
            <span v-else>
                {{ redemptionItem.deliveryStatus | statusTranslate }}
            </span>
            <a href="#" @click="$bvModal.show('modal-delivery-record')"
                        class="">
                <img class="mr-2" src="../../assets/img/deliverystatus/history.svg"/>
                查看紀錄
            </a>
        </div>
        <div class="status-group">
            <span>
                更新送貨狀態
            </span>
            <AGCSelectGroup
              v-model="currentStatus"
              :options="statusOptions"
              rules="required"
              :disabled="loading"
            ></AGCSelectGroup>
        </div>
        <div class="row">
          <div class="action">
            <b-button variant="outline-secondary"
                      class="cancel"
                      @click="$bvModal.hide('modal-delivery-select')">
              取消
            </b-button>
            <b-button
              @click="$bvModal.show('modal-delivery-input')"
              variant="success"
              class="next"
              :disabled="currentStatus === null">
              下一步
            </b-button>
          </div>
        </div>
      </b-modal>
    <DeliveryInputModal :status="currentStatus"
                        :redemptionItem="redemptionItem"
                        :role="role"
                        @update="updateStatus">
    </DeliveryInputModal>
    <LoadingSpinner v-show="loading"></LoadingSpinner>
  </div>
</template>

<script>
import AGCSelectGroup from '@/components/form/AGCSelectGroup.vue';
import {
  BButton,
} from 'bootstrap-vue';
import DeliveryInputModal from '@/components/delivery-status/DeliveryInputModal.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  props: ['id', 'redemptionItem', 'role', 'deliveryStatus', 'loading'],
  components: {
    AGCSelectGroup,
    BButton,
    DeliveryInputModal,
    LoadingSpinner,
  },
  filters: {
    statusTranslate: (value) => {
      if (!value) return '';
      switch (value) {
        case 'DELIVERED':
          return '已發貨';
        case 'DELAYED':
          return '發貨延誤';
        default:
          return '待發貨';
      }
    },
  },
  computed: {
    statusOptions() {
      if (this.deliveryStatus === null) {
        return [
          { value: null, text: '請選擇送貨狀態' },
          { value: 'DELIVERED', text: '已發貨' },
          { value: 'DELAYED', text: '發貨延誤' },
        ];
      }
      if (this.deliveryStatus === 'DELAYED') {
        return [
          { value: null, text: '請選擇送貨狀態' },
          { value: 'DELIVERED', text: '已發貨' },
        ];
      }
      return [
        { value: null, text: '請選擇送貨狀態' },
      ];
    },
  },
  data: () => ({
    currentStatus: null,
  }),
  methods: {
    updateStatus(status) {
      this.$emit('update', status);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
    .modal{
        &-dialog {
            max-width: 700px;
        }

        &-header {
            padding: 20px;
            border: none;
        }

        &-title {
            margin: 0 auto;
            font-size: 18px;
            font-weight: 400;
            color: #3a4047;
        }

        &-header .close {
            margin: 0px;
            padding: 0px;
            font-size: 20px;
        }

        &-body {
            padding: 0 24px 24px 24px;
        }

        &-body .col-12 {
            padding: 0;
            text-align: right;
        }
    }

    .status-card{
        span {
            font-weight: bold;
        }

        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid #cae4fc;
        border-radius: 4px;
        background: #f5fafe;
        min-height: 54px;
        width: 100%;
        color: #174169;
        justify-content: space-between;
        font-size: 0.9em;
    }
    .status-group{
        span {
            font-weight: bold;
            font-size: 0.9em;
            padding-bottom: 10px;
            display: inline-block;
            width: 100%;
        }
        padding: 15px 0px;
    }

    .action {
      text-align: right;
      width: 100%;
      padding: 0px 15px;
      button {
          width: 114px;
          height: 42px;
          display: inline-block;
          margin-left: 15px;
      }
    }
}
</style>
